import { Box, Placeholder } from '@stitch-fix/mode-react';
const PreviousGalleryLoadingPlaceholder = () => {
  return <Box data-testid="previous-gallery-loading-placeholder">
      <Placeholder width="100%" height="400px" variant="rect" />
    </Box>;
};
export default PreviousGalleryLoadingPlaceholder;